import { AuthFlow } from "./pages";
import { AlertsProvider } from "./contexts/AlertsContext";

function App() {
  return (
    <AlertsProvider>
      <AuthFlow />
    </AlertsProvider>
  );
}
export default App;
